import React from 'react';

import { Typography } from '@lyearn/ui';
import { TypographyVariants } from '@lyearn/ui';

function Title({
  title,
  variant = 'display-xs',
  className = 'mb-20',
}: {
  title: string;
  variant?: TypographyVariants;
  className?: string;
}) {
  return (
    <Typography as="p" className={className} variant={variant}>
      {title}
    </Typography>
  );
}

export default Title;
